import React from "react";
import { Button, Modal, Form, Input, Card, Checkbox, Icon, message } from "antd";
// import zxcvbn from "zxcvbn";

import CircularProgress from "components/CircularProgress/index";
import { PASSWORD_REQUIREMENT_TEXT, } from "../../constants/messages";
import { regExp } from "../../constants/constants";

/**
  0 - too guessable: risky password. (guesses < 10^3) 
  1 - very guessable: protection from throttled online attacks. (guesses < 10^6) 
  2 - somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8) 
  3 - safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10) 
  4 - very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
**/

const FormItem = Form.Item;

class ChangePasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      confirmLoading: false,
      strongPwd: false
    };
  }

  handleSubmit = (e) => {
    const { strongPwd } = this.state;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.newPassword === values.confirmNewPassword) {
          if (strongPwd >= 1) {
            const data = { ...values };
            delete data.confirmNewPassword;
            this.props.onOk(data);
          } else {
            message.warning({ content: 'The password does not meet the password policy requirements!', key: 'passowrd-policy-validation' });
          }
        } else {
          message.error({ content: 'The new password and confirmation password do not match!', key: 'passowrd-mismatch-validation' });
        }
      }
    });
  };

  validatePasswordStrength = (rule, value, callback) => {
    var strongRegex = new RegExp(regExp);
    let regexResult = strongRegex.test(value);

    this.setState({
      strongPwd: regexResult
    }, () => {
      callback();
    })
  };

  render() {
    const { confirmLoading, strongPwd } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { showMessage, loader, alertMessage, email, formData } = this.props;
    return (
      <Modal title="Change Password"
        visible={this.props.visible}
        confirmLoading={confirmLoading}
        onCancel={this.props.onCancel}
        footer={null}
        className="cutom-login-modal custom-login-body"
      >
        <Form onSubmit={this.handleSubmit} className="gx-login-form gx-form-row0" style={{ marginBottom: '-15px' }}>
          <FormItem className="gx-mb-4">
            {getFieldDecorator('email', {
              initialValue: email,
              rules: [{ required: true, message: 'Please input your email!' }],
            })(
              <Input disabled={true} prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Username" />
            )}
          </FormItem>
          <FormItem className="gx-mb-4">
            {getFieldDecorator('currentPassword', {
              initialValue: formData.currentPassword,
              rules: [{ required: true, message: 'Please input your current password!' }],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password"
                placeholder="Current Password" />
            )}
          </FormItem>
          <FormItem className="gx-mb-4">
            {getFieldDecorator('newPassword', {
              initialValue: formData.newPassword,
              rules: [
                { required: true, message: 'Please input your new password!' },
                { validator: this.validatePasswordStrength }
              ],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password"
                placeholder="New Password" />
            )}
          </FormItem>
          <FormItem className="gx-mb-4">
            {getFieldDecorator('confirmNewPassword', {
              initialValue: formData.confirmNewPassword,
              rules: [
                { required: true, message: 'Please input your confirm password!' },
              ],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password"
                placeholder="Confirm New Password" />
            )}
          </FormItem>
          <div style={{ marginTop: "-8px", marginBottom: "15px" }}>
            <span style={{ fontSize: "10px", fontStyle: "italic" }}>Password Policy: {PASSWORD_REQUIREMENT_TEXT}</span>
          </div>
          <FormItem className="gx-mb-0">
            <Button type="primary" disabled={!strongPwd} htmlType="submit" className="login-form-button" style={{ width: '335px' }}>
              Change Password
            </Button>

            {this.props.changePasswordAtLogon ? (
              <Button type="primary" onClick={this.props.userSignOut} className="login-form-button" style={{ width: '335px' }}>
                Logout
              </Button>
            ) : (
              null
            )
            }

          </FormItem>
        </Form>
        {loader &&
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        }
        {showMessage &&
          message.error(alertMessage)}
      </Modal >
    );
  }
}
const ChangePasswordModalForm = Form.create()(ChangePasswordModal);

export default ChangePasswordModalForm;
